import { find, pick } from 'lodash';

class CategoriesSelectController {

  constructor(categoriesService, messageService) {
    this.categoriesService = categoriesService;
    this.messageService = messageService;
  }

  $onInit() {
    this.value = this.value || [];
    this.categoriesService.hierarchyFind('flatten')
      .then(categories => {
        this.categories = this.addParents(categories.flat);

        if (this.value.length) {
          for( let i in this.value) {
            this.value[i] = find(this.categories, {'id': this.value[i].event_category_id});
          }
        }
      })
      .catch(errors => {
        this.messageService.failure(errors);
        this.messageService.push();
      })
    ;
  }

  addParents(categories){
    for (let i = 0, l = categories.length; i<l; i++){
      categories[i].displayname = categories[i].name;
      if (categories[i].parent) {
        categories[i].displayname += ' (Parent: '+find(categories, {'id': parseInt(categories[i].parent, 10)}).name +')';
      }
    }
    return categories;
  }
}

CategoriesSelectController.$inject = [ 'categoriesService', 'messageService' ];

export default CategoriesSelectController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/categories.select.controller.js